<template>
  <navigation
    v-bind:sub_components_list="subComponentsList"
    v-bind:labels="labels"
    v-bind:default_key="'sessions'"
    v-bind:sync_with_route="true" />
</template>

<script setup lang="ts">
  import navigation from '@/views/_espace/_refonte/stage/_stagiaire/utils/navigation.vue';

  import sessions from '@/views/_espace/_refonte/stage/_stagiaire/sessions/sessions.vue';
  import sessionsdone from '@/views/_espace/_refonte/stage/_stagiaire/sessions/sessionsdone.vue';

  const labels: Record<string, string> = {
    sessionsdone: 'Sessions terminées',
    sessions: 'Prochaines sessions'
  };

  const subComponentsList = {
    sessions,
    sessionsdone
  };
</script>

<style lang="scss" scoped></style>
